import axios from '@/axios';
import router from '@/routes/router';
import swal from 'sweetalert2';


const state = {
    revisions: {
        docs: []
    },
    revisionsDashboard: {
        docs: []
    },
    loading: false, 
    revision: null,
    attachmentLoading: false,
};

const actions = {
    // Sorry por mi vida loca
    async getAllDashboard({ commit,dispatch }, query) {
        commit('getAllDashboardRequest');
        const params = query ? query : null
        return new Promise(async (resolve, reject) => {
            try{
                const res = await axios
                    .get(`/api/revisions`,
                    {params})
                commit('getAllDashboardSuccess', res.data);
                resolve(res.data)
            } catch(e){
                commit('getAllDashboardFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e);
            };
        })
    },
    // Sorry por mi vida loca
    async getAllAll({ commit,dispatch }, query) {
        commit('getAllRequest');
        const params = query ? query : null
        return new Promise(async (resolve, reject) => {
            try{
                const res = await axios
                    .get(`/api/revisions`,
                    {params})
                commit('getAllSuccess', res.data);
                resolve(res.data)
            } catch(e){
                commit('getAllFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e);
            };
        })
    },

    async getAll({ commit,dispatch }, params) {
        let engineId
        if (typeof params === 'string'){
            engineId = params
        }  else {
            engineId = params.engineId
        }
        commit('getAllRequest');
        return new Promise(async (resolve, reject) => {
            try{
                const res = await axios
                    .get(`/api/engines/${engineId}/revisions`,{
                        params: {
                            limit: params.limit?  params.limit : 100,
                            populate: params.populate ? params.populate : 'author'
                        }
                    })
                commit('getAllSuccess', res.data);
                resolve(res.data)
            } catch(e){
                commit('getAllFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e);
            };
        })
    },

    async get({ commit,dispatch }, {engineId, id}) {
        commit('getRequest');
        return new Promise(async (resolve, reject) => {
            try{
                const res = await axios.get(`/api/engines/${engineId}/revisions/${id}`)
                commit('getSuccess', res.data);
                resolve(res.data)
            } catch(e){
                commit('getFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e);
            };
        });
    },

    async update({ commit,dispatch }, revision) {
        return new Promise( async(resolve,reject) => {            
            commit('updateRequest', revision);
            try{
                const res = await axios.put(`/api/engines/${revision.engine}/revisions/${revision.id}`,{revision})
                commit('updateSuccess', res.data);
                if (revision.sendTechnicalReport !== undefined && revision.sendTechnicalReport){
                    dispatch('alert/success', 'Revisione inviata e salvata correttamente', { root: true });
                } else{
                    dispatch('alert/success', 'Revisione salvata correttamente', { root: true });
                }
                resolve(res.data)
            } catch(e){
                commit('updateFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e)
            };
        })
    },

    async create({ commit,dispatch }, {engineId, revision}) {
        return new Promise( async(resolve,reject) => {            
            commit('createRequest', revision);
            try{
                const res = await axios.post(`/api/engines/${engineId}/revisions`,{revision})
                commit('createSuccess', res.data);
                dispatch('alert/success', 'Revisione creata correttamente', { root: true });
                setTimeout(() => {router.push(`/engines/${engineId}/revisions/${res.data.id}`) },500);
                resolve(res.data)
            } catch(e){
                commit('createFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e)
            };
        })
    },

    async delete({ commit,dispatch }, {engineId, id}) {
        const confirm = await swal.fire({
            title: 'Sicuro?',
            // text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Elimina Revisione tecnica',
            cancelButtonText: 'Annulla',
            reverseButtons: true
        })

        if (confirm.value) {
            commit('deleteRequest', id);
            try{
                const data = await axios.delete(`/api/engines/${engineId}/revisions/${id}`)
                dispatch('alert/success', 'Revisione rimossa correttamente', { root: true });
                commit('deleteSuccess', id);
            } catch(e){
                commit('deleteFailure', e);
                dispatch('alert/error', e, { root: true });
            };
        }
    },

    voidCurrent({commit}){
        commit('voidCurrent')    
    },

    async addAttachment({ commit, dispatch },{revisionId,attachment}) {
        commit('addAttachmentRequest');
        return new Promise(async (resolve, reject) => {
            const formData = new FormData();
            formData.append("attachment", attachment);
            try{
                const res = await axios.post(`/api/revisions/${revisionId}/revision-attachments`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                dispatch('alert/success', 'File caricato correttamente', { root: true });
                commit('addAttachmentSuccess', res.data);
                resolve(res.data)
            } catch(e){
                commit('addAttachmentFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e)
            };
        });
    },


    async updateAttachment({ commit, dispatch },{revisionId, id, revisionAttachment}) {
        commit('updateAttachmentRequest');
        try{
            const res = await axios.put(`/api/revisions/${revisionId}/revision-attachments/${id}`,
                {revisionAttachment})
            dispatch('alert/success', 'File modificato correttamente', { root: true });
            commit('updateAttachmentSuccess', res.data);
        } catch(e){
            commit('updateAttachmentFailure', e);
            dispatch('alert/error', e, { root: true });
        };        
    },

    async deleteAttachment({ commit, dispatch },{revisionId,id}) {

        const confirm = await swal.fire({
            title: 'Sicuro?',
            // text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Elimina elemento',
            cancelButtonText: 'Annulla',
            reverseButtons: true
        })

        if (confirm.value) {
            commit('removeAttachmentRequest');
            try{
                const data = await axios.delete(`/api/revisions/${revisionId}/revision-attachments/${id}`)
                dispatch('alert/success', 'Revisione rimossa correttamente', { root: true });
                commit('removeAttachmentSuccess', id);
            } catch(e){
                commit('removeAttachmentFailure', e);
                dispatch('alert/error', e, { root: true });
                
            };
        }
    }
};

const mutations = {
    getAllDashboardRequest(state) {
        state.loading = true;
    },
    getAllDashboardSuccess(state,revisions) {
        state.revisionsDashboard = revisions
        state.loading = false;
    },
    getAllDashboardFailure(state) {
        state.loading = false;
    },
    voidCurrent(state) {
      state.revision = null
    },
    getAllRequest(state) {
        state.loading = true;
        state.revisions = [];
    },
    getAllSuccess(state, revisions) {
        state.revisions = revisions;
        state.loading = false;
    },
    getAllFailure(state, error) {
        state.error = error;
        state.loading = false;
    },
    updateRequest(state, revision) {
        state.revision = {
            ...revision,
            loading: true
        };
    },
    updateSuccess(state, newRevision) {
        if (state.revisions.docs){
            state.revisions.docs = state.revisions.docs.map(revision => (revision.id === newRevision.id ? newRevision : revision))
        }
        state.revision = newRevision;
    },
    updateFailure(state, error) {        
        state.revision = { ...state.revision, error };
    },
    deleteRequest(state, id) {
        if (state.revisions.docs){
            state.revisions.docs = state.revisions.docs.map(revision =>
                revision.id === id
                    ? { ...revision, deleting: true }
                    : revision
            )
        }
    },
    deleteSuccess(state, id) {
        // remove deleted revision from state
        state.revisions.docs = state.revisions.docs.filter(revision => revision.id !== id)
    },
    deleteFailure(state, { id, error }) {
        // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
        state.revisions.docs = state.revisions.docs.map(revision => {
            if (revision.id === id) {
                // make copy of revision without 'deleting:true' property
                const { deleting, ...revisionCopy } = revision;
                // return copy of revision with 'deleteError:[error]' property
                return { ...revisionCopy, deleteError: error };
            }

            return revision;
        })
    },
    createRequest(state) {
        state.loading = true;
    },
    createSuccess(state, revision) {
        state.loading = false;
        state.revision = revision;
    },
    createFailure(state, e) {
        state.loading= false;
    },
    getRequest(state) {
        state.loading = true;
    },
    getSuccess(state, revision) {
        state.loading = false;
        state.revision = revision;
    },
    getFailure(state) {
        state.loading = false;
    },
    addAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    addAttachmentSuccess(state,attachment) {
        state.attachmentLoading = false;
        state.revision.attachments.push(attachment);
    },
    addAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
    updateAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    updateAttachmentSuccess(state) {
        state.attachmentLoading = false;
    },
    updateAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
    removeAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    removeAttachmentSuccess(state,attachmentId) {
        state.attachmentLoading = false;
        state.revision.attachments = state.revision.attachments.filter(att => att.id !== attachmentId)
    },
    removeAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
};

export const revisions = {
    namespaced: true,
    state,
    actions,
    mutations
};